
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const initialState = {
  isLoading: false,
  error: null,
  categories: [],
  subCategories: [],
  totalItems: 0,
  ItemsOnPage: 0
};


const slice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },


    getCategorySuccess(state, action) {
      state.isLoading = false;
      state.categories = action.payload;
    },

    getCategorySuccess2(state, action) {
      state.isLoading = false;
      state.categories = action.payload.items;
      state.totalItems = action.payload.totalItems;
      state.ItemsOnPage = action.payload.ItemsOnPage;
    },

    getSubCategorySuccess(state, action) {
      state.isLoading = false;
      state.subCategories = action.payload;
    },

    getSubCategorySuccess2(state, action) {
      state.isLoading = false;
      state.subCategories = action.payload.items;
      state.totalItems = action.payload.totalItems;
      state.ItemsOnPage = action.payload.ItemsOnPage;
    },

    addCategorySuccess(state, action) {
      const newCategory = action.payload;
      state.isLoading = false;
    },

  },
});

// Reducer
export default slice.reducer;



// ----------------------------------------------------------------------
export function getCategoryPagination(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/category/pagination/all', {
        params: {
          ...data
        }
      });
      dispatch(slice.actions.getCategorySuccess2(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCategory() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/category');
      dispatch(slice.actions.getCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addCategory(newCategory) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log("new", newCategory);
      const response = await axios.post('/api/category/add', newCategory);
      dispatch(slice.actions.addCategorySuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function updateCategory(id, newCategory) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      console.log("update", newCategory);
      const response = await axios.put(`/api/category/update/${id}`, newCategory);
      dispatch(slice.actions.addCategorySuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function getSubCategoryPagination(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/subCategory/pagination/all', {
        params: {
          ...data
        }
      });
      dispatch(slice.actions.getSubCategorySuccess2(response.data));
      // console.log(response.data,'response')
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function getSubCategory() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/subCategory');
      dispatch(slice.actions.getSubCategorySuccess(response.data));
      // console.log(response.data,'response')
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function addSubCategory(newSubCategory) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/subCategory/add', newSubCategory);
      dispatch(slice.actions.addCategorySuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function updateSubCategory(id, newSubCategory) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/subCategory/update/${id}`, newSubCategory);
      dispatch(slice.actions.addCategorySuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  }
}
export function deleteCategory(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`/api/category/${id}`);
      dispatch(slice.actions.addCategorySuccess(response.data));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteSubCategory(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/subCategory/delete/${id}`);
      dispatch(slice.actions.addCategorySuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      console.log('error')
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateUser(ID, updateUser) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/user/update', { ...updateUser, ID });
      console.log(response, 'userresponse')
      dispatch(slice.actions.updateUserSuccess(response.data.event));
      return { payload: {} };
    } catch (error) {
      if (error.message === 'Email already in use') {
        // Handle the specific error
        dispatch(slice.actions.hasError(error));
        console.log('Email already in use');
        return { payload: { error: 'Email already in use' } };
      }
      // Handle other errors
      dispatch(slice.actions.hasError(error));
      console.log('Generic error');
      return { payload: { error: 'Email already in use' } };
    }
  };
}








// Append paginated categories for infinite scroll/local cache
export function appendCategories(data) {
  return async () => {
    try {
      const response = await axios.get('/api/category/pagination/all', {
        params: {
          ...data
        }
      });
      // Return items, total count, and page for local use
      return {
        items: response.data.items,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        page: data.page || 1
      };
    } catch (error) {
      return { items: [], totalItems: 0, totalPages: 1, page: data.page || 1, error };
    }
  };
}